<script setup>
import {onBeforeMount, onMounted, onUpdated, ref, watch} from "vue";
import axios from "@/axios";
import {useComStore, useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();
// data는 {'codeId', 'codeNm'} 으로 구성
const props = defineProps(['meeting', 'readonly', "searchMode", 'data', 'isReset', 'label'])
const emits = defineEmits(['set_meetingType'])
const meetingType = ref();
const isReadonly = ref(false);
const searchType = ref([]);
const items = ref([]);
const comStore = useComStore();

const changeMeetingType = (e)=>{
  meetingType.value = e;
  emits("set_meetingType", e)
}
onUpdated(()=>{
  isReadonly.value = props.readonly ?? false
})
onMounted(()=>{
  if(props.data) items.value = [props.data ,...comStore.getCodeType('meetingType')];
  else items.value = comStore.getCodeType('meetingType');
  console.log(searchType.value)
})


watch(()=>props.meeting, ()=>{
  meetingType.value = props.meeting ?? null
})
watch(()=>props.isReset , ()=>{
  console.log("meetingType IsReset : " + props.isReset)
  if(props.isReset){
    meetingType.value= null ;
  }
})
</script>

<template>
  <v-select
      v-model="meetingType"
      @update:modelValue="changeMeetingType"
      :items="items"
      item-value="codeId"
      item-title="codeNm"
      :readonly="isReadonly"
      :label="label"
      :placeholder="!label ? languageStore.get('select') : undefined"
      variant="outlined"
      density="compact"
      hide-details="auto"
  />
</template>

<style scoped>

</style>